<template>
    <div class="clearfix pb-3 px-0 ml-0 col-sm-12">  <!-- Abdullah chnaged class here. it was. clearfix company-form-container rounded mt-4 pb-5 mx-auto-->


        <!-- Abdullah commented this code here  -->
        <!-- <div class=" row no-gutters py-2 mb-3 border-bottom ">
            <div class="col-sm-6 px-3 company-form-box-title">Tax Info</div>
            <template v-if="this.$acl['company/tax_info'] == 2"><div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" v-if="readonly" @click="trz_display()"><button class="edit-icon"><i class="fa fa-pencil-alt"></i></button></div></template>

        </div> -->
        <!-- Abdullah commented upto this.  -->

        <!-- Abdullah added this block of code here  -->
        <div class="row no-margin" v-if="readonly">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Tax Info <template v-if="this.$acl['company/info'] == 2"><button class="edit-icon" v-if="readonly" @click="trz_display('company-taxinfo-form')"><i class="fa fa-pencil-alt"></i></button></template></h4>
                </div>
                <div class="ibox-content">
                    <div class="row front-public-info-wrapper">
                        <div class="col-md-5 pl-0 d-flex align-items-center">
                            <div class="employee-inner-content pl-0">
                                <dl class="row py-3 px-0 public-info-last company-public-info border-0">
                                    <dt class="col-sm-5 text">Tax Zone:</dt>
                                    <dd class="col-sm-7 value">{{fdata.tax_zone}}</dd>

                                    <dt class="col-sm-5 text">Tax Circle:</dt>
                                    <dd class="col-sm-7 value">{{ fdata.tax_circle }}</dd>

                                    <dt class="col-sm-5 text">Code:</dt>
                                    <dd class="col-sm-7 value">{{fdata.code}}</dd>
                                </dl>
                            </div>
                        </div>
                        <div class="col-md-7 d-flex align-items-center">
                            <dl class="row py-3 px-0 public-info-last company-public-info pl-2">
                                <dt class="col-sm-6 text d-flex align-items-center">Company <b class="ml-1">TIN:</b><span style="color: #34444C; margin-left: 10px; font-size: 15px;">{{fdata.tin}}</span></dt>
                                <dd class="col-sm-6 value"><template v-if="fdata.etin_scan"><b-link class="px-4 d-inline-block btn btn-primary float-right" :href="$api_url+'/images/company/' + fdata.etin_scan" target="_blank"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-2" height="19px" width="16px" />Download Certificate</b-link></template></dd>

                                <dt class="col-sm-6 text d-flex align-items-center">Company <b class="ml-1">BIN:</b><span style="color: #34444C; margin-left: 10px; font-size: 15px;">{{fdata.bin}}</span></dt>
                                <dd class="col-sm-6 value"><template v-if="fdata.bin_scan"><b-link class="px-4 d-inline-block btn btn-primary float-right" :href="$api_url+'/images/company/' + fdata.bin_scan" target="_blank"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-2" height="19px" width="16px" />Download Certificate</b-link></template></dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Abdullah added this block of code here upto this.  -->

        <div :class="this.trz_display_form">
            <template v-if="this.flg == 1">  <!-- abdullah added this template here  -->
                <b-form @submit.stop.prevent="onSubmit">

                    <!-- Abdullah added this block of code here  -->
                    <div class="clearfix row form-btn-container rounded mb-5 mx-3">
                        <div class="col-md-4 pl-0">
                            <b-button v-if="new_capability && readonly == false" type="button" @click="set_go_back(1)"  class="custom-wizard-btn"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back</b-button>
                        </div>
                        <div class="col-md-4 text-center custom-wizard-title">Tax Info</div>
                        <div class="col-md-4 pr-0 text-right"><b-button v-if="new_capability && readonly == false" type="button" @click="set_go_next(1)"  class="">Skip <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
                    </div>
                    <!-- Abdullah added this block of code here upto this. -->

                    <!-- Abdullah chnaged this block stratcure with two column  -->
                    <b-overlay :show="showoverlay" rounded="sm">
                        <div class="clearfix">
                            <div class="col-md-12"> <!-- Abdullah chnaged class here. it was col-md-6 float-left px-3. -->

                                <!-- Abdullah reaggraned here it was in 2nd position. Moved on 1st position. -->
                                <b-form-group id="tax_zone-group" label="Tax Zone" class="required-field" label-for="tax_zone">
                                    <b-form-select :disabled="readonly" id="tax_zone" name="tax_zone" v-model="fdata.tax_zone" v-validate="{ required: true }" :options="tax_zones" :state="validateState('tax_zone')"  @change="setCompanyCode($event)" aria-describedby="tax_zone-feedback" data-vv-as="Tax Zone"></b-form-select>
                                    <b-form-invalid-feedback id="tax_zone-feedback">{{ veeErrors.first('tax_zone') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <!-- Abdullah reaggraned here it was in 3nd position. Moved on 2st position. -->
                                <b-form-group id="tax_circle-group" label="Tax Circle" class="required-field" label-for="tax_circle">
                                    <b-form-input :disabled="readonly" id="tax_circle" name="tax_circle" v-model="fdata.tax_circle" v-validate="{ required: true }" :state="validateState('tax_circle')" aria-describedby="tax_circle-feedback" data-vv-as="Tax Circle"></b-form-input>
                                    <b-form-invalid-feedback id="tax_circle-feedback">{{ veeErrors.first('tax_circle') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <!-- Abdullah reaggraned here it was in 4nd position. Moved on 3rd position. -->
                                <b-form-group id="code-group" label="Code" label-for="code">
                                    <b-form-input  id="code" name="code" v-model="fdata.code" readonly></b-form-input>
                                </b-form-group>

                            </div>

                            <div class="col-md-12"> <!-- Abdullah added this div here. -->
                                <div class="row"> <!-- Abdullah added this div here. -->
                                    <div class="col-sm-12 col-md-6"> <!-- Abdullah added this div here. -->
                                        <b-form-group id="tin-group" label="Company TIN" class="required-field mb-0" label-for="tin">
                                            <b-form-input :disabled="readonly" id="tin" name="tin" v-model="fdata.tin" v-validate="{ required: true, min: 12 , max:12}" :state="validateState('tin')" aria-describedby="tin-feedback" data-vv-as="Company TIN"></b-form-input>
                                            <b-form-invalid-feedback id="tin-feedback">{{ veeErrors.first('tin') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="form_etin_scan-group" class="custom-file-uploader" label="" label-for="form_etin_scan">
                                            <b-form-file @change="checkFileType($event , 'form_etin_scan' , ['.pdf'])" :disabled="readonly" id="form_etin_scan"  accept=".pdf" v-model="form_etin_scan"   placeholder="Drag and drop files here or click to browse" drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of TIN"></b-form-file>
                                            <b-form-invalid-feedback id="form_etin_scan-feedback">{{ veeErrors.first('form_etin_scan') }}</b-form-invalid-feedback>

                                        </b-form-group>
                                    </div>

                                    <div class="col-sm-12 col-md-6">
                                        <b-form-group id="bin-group" label="Company BIN" label-for="bin" class="mb-0">
                                            <b-form-input :disabled="readonly" id="bin" name="bin" v-model="fdata.bin" v-validate="{  }" :state="validateState('bin')" aria-describedby="bin-feedback" data-vv-as="Company BIN"></b-form-input>
                                            <b-form-invalid-feedback id="bin-feedback">{{ veeErrors.first('bin') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group id="form_bin_scan-group"  class="custom-file-uploader" label="" label-for="form_bin_scan">
                                            <b-form-file @change="checkFileType($event , 'form_bin_scan' , ['.pdf'])" :disabled="readonly" id="form_bin_scan"  accept=".pdf" v-model="form_bin_scan"   placeholder="Drag and drop files here or click to browse" drop-placeholder="Drop file here..." aria-describedby="form_bin_scan-feedback" data-vv-as="Scanned copy of BIN"></b-form-file>
                                            <b-form-invalid-feedback id="form_bin_scan-feedback">{{ veeErrors.first('form_bin_scan') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                    </div>
                                </div>
                            </div>
                            <!-- Abdullah chnaged this block stratcure with two column  upto this.-->

                            <!-- Abdullah commented this block of code  -->
                            <!-- <div class="col-md-6 float-right px-3">
                                <div class="row">
                                    <div class="col-sm-12">

                                    </div>
                                    <div class="col-sm-12 align-self-center text-center" v-if="fdata.etin_scan">
                                        <b-link class="px-4 py-2 mb-4 d-inline-block btn btn-primary" :href="$api_url+'/images/company/' + fdata.etin_scan" target="_blank"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-3" height="19px" width="16px" />Download e-TIN certificate</b-link>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12">

                                    </div>
                                    <div class="col-sm-12 align-self-center text-center" v-if="fdata.bin_scan">
                                        <b-link class="px-4 py-2 mb-4 d-inline-block btn btn-primary" :href="$api_url+'/images/company/' + fdata.bin_scan" target="_blank"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-3" height="19px" width="16px" />Download company BIN</b-link>
                                    </div>
                                </div>
                            </div> -->

                            <div class="col-sm-12 px-3 text-center" v-if="this.$acl['company/tax_info'] == 2"> <!-- Abdullah added class here text-center.-->
                                <!---->
                                <!--<b-button v-if="new_capability" type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3">Save</b-button>-->
                                <template v-if="this.flg == 1">

                                    <div class="text-center">
                                            <b-button v-if="new_capability && readonly == false " type="submit" @click="set_go_next()"  class=" mt-3 mr-3 btn-primary">Save & Go Next</b-button>
                                            <b-button v-if="new_capability && readonly == false" type="submit" @click="setfinish()"  class=" mt-3 mx-3 btn-primary">Finish</b-button>
                                    </div>


                                    <!-- Abdullah commented this block of code -->
                                    <!-- <b-button v-if="new_capability && readonly == false " type="submit" @click="set_go_next()" variant="success" class="float-right mt-3 mr-3">Save & Go Next</b-button>
                                    <b-button v-if="new_capability && readonly == false" type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Skip</b-button>
                                    <b-button v-if="new_capability && readonly == false" type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button>
                                    <b-button v-if="new_capability && readonly == false" type="submit" @click="setfinish()" variant="success" class="float-right mt-3 mx-3">Finish</b-button> -->
                                    <!-- Abdullah commented this block of code upto this.-->
                                </template>
                                <template v-else>

                                    <div class="text-center">
                                            <b-button v-if="new_capability && readonly == false"  type="submit" @click="disable_set_go_next()"  class="mt-3 btn-primary">Update</b-button>
                                    </div>

                                    <!-- Abdullah commeted this line of code  -->
                                    <!-- <b-button v-if="new_capability && readonly == false"  type="submit" @click="disable_set_go_next()" variant="success" class="float-right mt-3">Save</b-button> -->
                                </template>

                            </div>
                        </div>
                        <!--<div class="col-sm-12 px-3"><b-button v-if="new_capability" type="submit" variant="primary" class="float-right mt-3">Save</b-button></div>-->
                    </b-overlay>
                </b-form>
            </template>

            <!-- Abdullah added this block of code -->
            <template v-else>
                <b-modal id="company-taxinfo-form" title="Edit Tax Info Details" dialog-class="w-1000"  hide-footer @hidden="onHidden">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-overlay :show="showoverlay" rounded="sm">
                        <div class="clearfix">
                            <div class="col-md-12">
                                <b-form-group id="tax_zone-group" label="Tax Zone" class="required-field" label-for="tax_zone">
                                    <b-form-select :disabled="readonly" id="tax_zone" name="tax_zone" v-model="fdata.tax_zone" v-validate="{ required: true }" :options="tax_zones" :state="validateState('tax_zone')"  @change="setCompanyCode($event)" aria-describedby="tax_zone-feedback" data-vv-as="Tax Zone"></b-form-select>
                                    <b-form-invalid-feedback id="tax_zone-feedback">{{ veeErrors.first('tax_zone') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="tax_circle-group" label="Tax Circle" class="required-field" label-for="tax_circle">
                                    <b-form-input :disabled="readonly" id="tax_circle" name="tax_circle" v-model="fdata.tax_circle" v-validate="{ required: true }" :state="validateState('tax_circle')" aria-describedby="tax_circle-feedback" data-vv-as="Tax Circle"></b-form-input>
                                    <b-form-invalid-feedback id="tax_circle-feedback">{{ veeErrors.first('tax_circle') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="code-group" label="Code" label-for="code">
                                    <b-form-input  id="code" name="code" v-model="fdata.code" readonly></b-form-input>
                                </b-form-group>

                            </div>

                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <b-form-group id="tin-group" label="Company TIN" class="required-field mb-0" label-for="tin">
                                            <b-form-input :disabled="readonly" id="tin" name="tin" v-model="fdata.tin" v-validate="{ required: true, min: 12 , max:12}" :state="validateState('tin')" aria-describedby="tin-feedback" data-vv-as="Company TIN"></b-form-input>
                                            <b-form-invalid-feedback id="tin-feedback">{{ veeErrors.first('tin') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group id="form_etin_scan-group" class="custom-file-uploader" label="" label-for="form_etin_scan">
                                            <b-form-file @change="checkFileType($event , 'form_etin_scan' , ['.pdf'])" :disabled="readonly" id="form_etin_scan"  accept=".pdf" v-model="form_etin_scan"   placeholder="PDF only" drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of TIN"></b-form-file>
                                            <b-form-invalid-feedback id="form_etin_scan-feedback">{{ veeErrors.first('form_etin_scan') }}</b-form-invalid-feedback>

                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <b-form-group id="bin-group" label="Company BIN" class="mb-0" label-for="bin">
                                            <b-form-input :disabled="readonly" id="bin" name="bin" v-model="fdata.bin" v-validate="{  }" :state="validateState('bin')" aria-describedby="bin-feedback" data-vv-as="Company BIN"></b-form-input>
                                            <b-form-invalid-feedback id="bin-feedback">{{ veeErrors.first('bin') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group id="form_bin_scan-group"  class="custom-file-uploader" label="" label-for="form_bin_scan">
                                            <b-form-file @change="checkFileType($event , 'form_bin_scan' , ['.pdf'])" :disabled="readonly" id="form_bin_scan"  accept=".pdf" v-model="form_bin_scan"   placeholder="PDF only" drop-placeholder="Drop file here..." aria-describedby="form_bin_scan-feedback" data-vv-as="Scanned copy of BIN"></b-form-file>
                                            <b-form-invalid-feedback id="form_bin_scan-feedback">{{ veeErrors.first('form_bin_scan') }}</b-form-invalid-feedback>

                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 px-3 text-center" v-if="this.$acl['company/tax_info'] == 2">
                                <!---->
                                <!--<b-button v-if="new_capability" type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3">Save</b-button>-->



                                <template v-if="this.flg == 1">

                                    <!-- barsha change button colour and align-items-center -->

                                    <div class="text-center">
                                        <b-button v-if="new_capability && readonly == false " type="submit" @click="set_go_next()"  class=" mt-3 mr-3 btn-primary">Save & Go Next</b-button>
                                        <b-button v-if="new_capability && readonly == false" type="button" @click="set_go_next(1)"  class=" mt-3 mr-3 btn-primary">Skip</b-button>
                                        <b-button v-if="new_capability && readonly == false" type="button" @click="set_go_back(1)"  class=" mt-3 mr-3 btn-primary">Go Back</b-button>
                                        <b-button v-if="new_capability && readonly == false" type="submit" @click="setfinish()"  class=" mt-3 mx-3 btn-primary">Finish</b-button>
                                    </div>


                                </template>
                                <template v-else>
                                    <div class="text-center">
                                        <b-button v-if="new_capability && readonly == false"  type="submit" @click="disable_set_go_next()"  class="mt-3 btn-primary">Update</b-button>
                                    </div>
                                </template>

                            </div>
                        </div>
                            <!--<div class="col-sm-12 px-3"><b-button v-if="new_capability" type="submit" variant="primary" class="float-right mt-3">Save</b-button></div>-->
                        </b-overlay>
                    </b-form>
                </b-modal>
            </template>
            <!-- Abdullah added this block of code up to this -->
        </div>
    </div>
</template>
<script>


    export default{

        mounted() {

            // Abdullah added this condition here
            if(this.flg == 1)
                this.readonly = false;

        },
        props: ['flg' , 'ce_flg' , 'check_ce'],
        components: {

        },
        data(){

            return {

                cu:window.location.href,
                ce:false,
                tax_zones:[],
                tax_circle:[],
                company_id : 0,

                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : false,
                go_back : false,
                go_next : false,
                finish : false,

                errormsg:[],
                fdata: {tin: null, tax_zone: null, tax_circle: null, bin: null,},

                form_etin_scan: null,
                form_bin_scan: null,
                new_capability:true,

                trz_display_form : '',
                readonly : true,

            }
        },
        methods:{

            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.fdata.tax_zone != null)
                {
                    if(this.fdata.tax_zone.length > 0)tmp_flg = 1;
                }
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            setfinish(x){
                this.finish = true;

                this.go_next = false;
                this.go_back = false;

                if(x == 1)
                    this.showMessage();
            },

            // Abdullah modified this function by added from_name
            trz_display: function(form_name)
            {
                this.trz_display_form = '';
                this.readonly = !this.readonly;
                this.$bvModal.show(form_name);
            },

            // Abdullah added this function here
            onHidden: function()
            {
                this.readonly = !this.readonly;
            },

            getTaxZone: function()
            {

                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/taxzone' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){

                    this.tax_zones = [{ value: null, text: "Select..." } ] . concat(response.data.tax_zone);
                    this.tax_circle = response.data.tax_circle;
                }.bind(this)).catch(function (error){this.serverError(error);});
            },
            setCompanyCode: function(event)
            {

                this.fdata.code = this.tax_circle[event];

            },
            editCompany:function(x)
            {


                if(!this.checkNet()) return false;
                this.successmsg = null;
                this.errormsg = [];
                this.new_capability = true;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    this.$validator.reset();

                    if(response.data != '')
                    {
                        this.fdata = response.data;
                        if(this.fdata.bin == 'null') this.fdata.bin = '';
                        this.file = null;
                        this.showMessage();
                        this.company_id =  response.data.id;
                    }

                }.bind(this)).catch(function (error){this.serverError(error);});
                this.$bvModal.show('bv-modal-example');

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.successmsg = false;
                this.warningmsg = false;
                this.dangermsg = false;
                //this.showMessage();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    if(this.form_bin_scan)
                        formData.append('form_bin_scan', this.form_bin_scan);

                    if(this.form_etin_scan)
                        formData.append('form_etin_scan', this.form_etin_scan);

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    axios.post(this.$api_url+'/company/save?flg=1', formData, config)
                            .then(function (response)
                            {

                                this.fdata = response.data;
                                if(this.fdata.bin == 'null') this.fdata.bin = '';
                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });


                                this.showMessage();
                                this.showoverlay = false;
                                this.$validator.reset();

                                // this.readonly = true;
                                this.ce = true;
                                this.trz_display_form = '';

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;
                                for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                            });
                });
            },


            selectCompany:function(x)
            {
                if(!this.checkNet()) return false;
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                    .then(function (response)
                    {
                        window.location.href = this.$api_url+'/company/info';

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.serverError(error);
                        this.errormsg = error.response.data.errors;
                    });

            },

            checkCapability:function()
            {
                if(!this.checkNet()) return false;
                this.successmsg = null;
                axios.get(this.$api_url+'/company/capabilities' , {
                    params: {
                        action: 'addnew'
                    }
                }).then(function(response){
                  this.new_capability = response.data.capability;
                  if(response.data.capability == false){
                    this.errormsg = [];
                    this.errormsg[0] = ["You are not allowed to add more company!!!"];
                  }
                  else
                  this.errormsg = [];

                }.bind(this));
            },

        },
        created: function(){

            this.getTaxZone();
            this.editCompany();
            this.$validator.reset();


        }
    }
</script>
